/* @flow */
import * as React from 'react';

const Home = props => (
  <svg
    width={103}
    height={89}
    viewBox="0 0 103 89"
    fillRule="evenodd"
    stroke="#1C1F34"
    strokeWidth={3}
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      points="12.582 42.29 51.294 9.558 90.498 42.29 90.498 86.921 12.582 86.921"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#3A427C"
      d="M73.55,29.797 L52.286,12.351 C52.285,12.35 52.284,12.35 52.284,12.35 C52.124,12.219 51.944,12.124 51.753,12.068 C51.729,12.061 51.704,12.06 51.68,12.054 C51.609,12.036 51.537,12.019 51.464,12.012 C51.443,12.01 51.422,12.013 51.401,12.012 C51.324,12.008 51.247,12.005 51.17,12.013 C51.168,12.013 51.165,12.014 51.163,12.014 C50.953,12.036 50.747,12.105 50.557,12.216 C50.488,12.256 50.42,12.297 50.357,12.348 C50.356,12.349 50.355,12.35 50.353,12.351 L13.832,42.323 C13.862,43.619 13.878,44.917 13.884,46.22 L51.319,15.498 L71.178,31.791 C71.712,30.871 72.549,30.127 73.55,29.797"
      opacity={0.2}
    />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#E8EBF7"
      points="33.879 52.9 64.686 27.391 95.884 52.9 95.884 87.683 33.879 87.683"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#3A427C"
      d="M65.757,31.231 C65.755,31.231 65.755,31.23 65.754,31.23 C65.611,31.111 65.448,31.026 65.275,30.975 C65.252,30.968 65.231,30.967 65.209,30.962 C65.144,30.946 65.079,30.931 65.013,30.924 C64.993,30.923 64.975,30.925 64.956,30.924 C64.886,30.921 64.816,30.918 64.748,30.925 C64.745,30.925 64.743,30.926 64.74,30.926 C64.55,30.946 64.364,31.008 64.191,31.109 C64.13,31.145 64.067,31.182 64.011,31.229 C64.01,31.23 64.008,31.23 64.007,31.231 L33.843,55.979 C33.871,57.152 33.886,58.327 33.892,59.506 L64.882,34.08 L96.275,59.837 C96.284,58.66 96.3,57.483 96.32,56.306 L65.757,31.231 Z"
      opacity={0.2}
    />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      points="71.395 87.421 85.818 87.421 85.818 69.252 71.395 69.252"
    />
    <path d="M5.278,87.5 L101.247,87.5" />
    <polyline points="12.5 43.5 12.5 87.5 93.5 87.5" />
    <polyline points="34.5 53.5 34.5 87.5 96.505 87.5 96.505 53.5" />
    <polyline
      stroke="none"
      strokeWidth={1}
      fill="#3A427C"
      points="99.274 48.52 99.274 56.756 64.882 28.54 30.49 56.756 30.49 48.52 64.882 20.303"
    />
    <polyline points="99.274 48.52 99.274 56.756 64.882 28.54 30.49 56.756 30.49 48.52 64.882 20.303" />
    <polyline
      stroke="none"
      strokeWidth={1}
      fill="#AEB8E0"
      points="35.769 13.459 35.769 10.32 25.689 10.32 25.689 21.729"
    />
    <polyline points="35.5 13.526 35.5 10.5 25.5 10.5 25.5 21.5" />
    <polygon points="71.5 87.5 85.5 87.5 85.5 69.5 71.5 69.5" />
    <polygon points="71.5 65.41 78.5 60.5 85.5 65.41 85.5 68.5 71.5 68.5" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#3A427C"
      d="M61.892,76.367 L61.892,77.246 L43.108,77.246 L43.108,76.747 C42.102,77.152 40.977,77.232 40,76.849 L40,78.622 C40,79.384 40.696,80 41.554,80 L63.446,80 C64.304,80 65,79.384 65,78.622 L65,76 C64.068,76.432 62.943,76.554 61.892,76.367"
      opacity={0.2}
    />
    <polygon stroke="none" strokeWidth={1} fill="#FFFFFF" points="41 75 62 75 62 56 41 56" />
    <polygon points="41.5 76.5 63.5 76.5 63.5 56.5 41.5 56.5" />
    <path d="M52.5,56.985 L52.5,75.997" />
    <path d="M41.68,66.5 L63.178,66.5" />
    <path stroke="#3A427C" strokeWidth={1.462} d="M10.36,44.184 L5.401,49.143" />
    <polyline
      stroke="none"
      strokeWidth={1}
      fill="#3A427C"
      points="99.274 48.52 51.22 9.412 8.837 44.184 8.837 36.273 51.22 1.5 79.295 24.535 79.295 32.261"
    />
    <polyline points="99.274 48.52 51.22 9.412 8.837 44.184 8.837 36.273 51.22 1.5 79.295 24.535 79.295 32.261" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#E8EBF7"
      d="M12.516,7.143 C6.432,7.143 1.5,62.694 1.5,68.778 C1.5,74.862 6.432,79.794 12.516,79.794 C18.6,79.794 23.532,74.862 23.532,68.778 C23.532,62.694 18.6,7.143 12.516,7.143"
    />
    <path d="M23.532,68.778 C23.532,62.694 18.6,7.143 12.516,7.143 C6.432,7.143 1.5,62.694 1.5,68.778 C1.5,74.862 6.432,79.794 12.516,79.794 C18.6,79.794 23.532,74.862 23.532,68.778 Z" />
    <path d="M12.5,79.794 L12.5,33.322" />
    <path d="M11.516,67.427 L6.643,62.554" />
  </svg>
);

export default Home;



// WEBPACK FOOTER //
// ./src/assets/images/icons/home.js